var app = require('../index');

//TEMP
//app.fn('subscribe.betaTester', function(e, el) {
//	jQuery.post('/subscribe-beta-tester')
//	.done(function() {
//		//redirect to homepage
//		window.location = '/';
//	})
//});

//REPLACED BY JQUERY CODE
//This is needed in order to catch the HTML5 'input' event which is the only event
//that gets triggered if the user presses the up/down arrows to change the number
/*
app.fn('subscribe.updateTotalGroupPrice', function(e, el) {
	this.model.set('_page.numUsers', el.value);

    var model = this.model,
        planId = model.get('_page.planId'),
        numUsers = model.get('_page.numUsers');

    //TODO the prices probably shouldn't be hard-coded here
    var prices = {
        'group-5-10': 69,
        'group-11-20': 65,
        'group-21-plus': 59
    }

    var pricePerUser = prices[planId];
    var totalPrice = pricePerUser * numUsers;

    model.set('_page.totalGroupPrice', '$' + totalPrice);
});
*/

//Subscribe
app.fn('subscribe.subscribe', saveSubscription);
app.fn('subscribe.renew', function(e, el, next, dom) {
	saveSubscription(e, el, next, dom, true);
});

function saveSubscription(e, el, next, dom, isRenewal) {
	e.preventDefault();
	var model = app.model;
	model.set('_page.isRenewal', isRenewal);

	//Validation
	//Use parsley for basic validation
	if (! $('#subscribe-form').parsley('validate') ) return false;
	if (!model.get('_page.specialPricing') &&  $('input[name=planId]:checked').length == 0) {
		alert('Please select a subscription plan');
		return;
	}
	if (model.get('_page.automaticRenewal') === undefined) {
		alert('Please select a renewal option (automatic or manual)');
		return;
	}

	var user = model.get('_page.user');
	var address = user.address;

	if (!address.stateCode && !address.stateName) {
		alert('Please enter or select your state/province');
		return;
	}
	
	//ensure that email is lowercase
	user.email = user.email.toLowerCase();

	// Disable the submit button to prevent repeated clicks
	$('#btn-purchase').prop('disabled', true)
		.html('Processing...');

	//if the user changed the email address on this form for whatever reason,
	//change the login email as well if they used their email to register (rather than Facebook, Google, etc.)
	//we don't want the confusion of multiple different email addresses...
	if (user.local) {
		user.local.email = user.email;
	}

	log(1)

	//store the country name in addition to the country code
	model.get('_page.countries').forEach(function(country) {
		if (country.code == address.countryCode) {
			address.countryName = country.name;
		}
	});

	log(2)

	//also store the state name
	//we only need to do this if there was a state dropdown for the selected country;
	//for countries without an auto-populated list of states, address.stateName was already bound
	if (address.stateCode) {
		model.get('_page.states').forEach(function(state) {
			if (state.code == address.stateCode) {
				address.stateName = state.name;
			}
		});
	}

	log(3)


	//TODO
	//IMPORTANT
	//check if email address already in system if entering email for first time or changing it

	// Save the user
	model.set('auths.' + user.id, user, function(err) {
		if (err) {
			alert('An error occurred saving your billing information. Please try again or contact us if the problem persists.');
			$('#btn-purchase').prop('disabled', false)
            	.html(model.get('_page.purchaseButtonLabel')); //restore original button label
			return;
		}

		log(4)

		//After the user is saved, send the payment info to Stripe
		
		//For renewals, if the card is already on file, payment is processed completely on the server-side
		if (model.get('_page.useCardOnFile')) {
			stripeResponseHandler(null, {});
		}
		else Stripe.card.createToken($('#subscribe-form'), stripeResponseHandler);
	})

//	jQuery.post('')
//	.done(function() {
//
//	})
//	.error(function() {
//		//alert('An error occurred')
//	})
}

function stripeResponseHandler(status, response) {
  var $form = $('#subscribe-form');
  var model = app.model;
	
  log(5)

  if (response.error) {
    // Show the errors on the form
    $form.find('.payment-errors').text(response.error.message);
    $('#btn-purchase').prop('disabled', false) //re-enable submit button
        .html(model.get('_page.purchaseButtonLabel'));
  } else {
    // token contains id, last4, and card type
    var token = response.id;

    // Submit the form via AJAX so we can display any payment errors (like a card declined error)

	var formData = $form.serialize();
	//Add the Stripe token to be submitted with the rest of the form data
	formData += '&stripeToken='+token;

	saveSubscriptionToDb(formData);
    //$form.get(0).submit();
  }
};

function saveSubscriptionToDb(formData) {
	var internalErrorMsg = 'An internal error occurred while attempting to process your payment. Please try again or contact us if that does not resolve it.';
	var model = app.model;
	
	var isRenewal = app.model.get('_page.isRenewal');
	$.ajax({
		url: '/subscribe/' + (isRenewal ? 'renew': 'create-subscription'),
		method: 'post',
		data: formData,
		dataType: 'json' //should get JSON back from the server
	})
	.done(function(data, textStatus, jqXHR) {
		if (data.subscriptionId) {
			//payment was successful
			//redirect to receipt page
			window.location = '/subscribe/receipt?subscriptionId=' + data.subscriptionId;
		}
		else if (data.error) {
			if (data.error.type == 'not_logged_in') {
				//TOOD make sure this almost never happens by periodically checking login status
				alert('It appears that your session has expired and you are no longer logged in. You will now be redirected to the login page. We apologize for the inconvenience.');
				window.location = '/login';
				return;
			}
			var msg = data.error.message;
			if (!msg) {
				msg = (typeof data.error == 'string' ? data.error: internalErrorMsg);
			}
			showPaymentError(msg);
		}
		else showPaymentError(internalErrorMsg);
	})
	.error(function(jqXHR) {
		showPaymentError(internalErrorMsg);
	});

	function showPaymentError(msg) {
		$('#payment-errors').html(msg);
		//re-enable the submit button
        $('#btn-purchase').prop('disabled', false) //re-enable submit button
            .html(model.get('_page.purchaseButtonLabel'));
	}
}


//TODO the prices probably shouldn't be hard-coded here
var prices = {
	'monthly': 29,
	'yearly': 79,
	'yearly-academic': 71,
    'group-5-10': 69,
    'group-11-20': 65,
    'group-21-plus': 59
}

app.fn('subscribe.applyCouponCode', function(e, el) {
	var model = this.model;

	var code = model.get('_page.couponCode');
	if (!code || code.trim() == '') {
		alert('Please enter a coupon code');
		return;
	}

	//TODO institutional pricing
	var planId = model.get('_page.planId');
	var priceBeforeDiscounts = prices[planId];
	var totalPrice = priceBeforeDiscounts;

	if (!planId) {
		alert('Please select a subscription plan first.');
		return;
	}

	var internalError = 'Internal error retrieving coupon code (this does not necessarily mean your coupon code is invalid). Please try again or contact us.';
	$.getJSON('/subscribe/get-stripe-coupon', {
		code: code,
		planId: planId
	})
	.done(function(data) {
		if (data.coupon) {
			var coupon = data.coupon;

			if (coupon.amount_off) {
				totalPrice -= parseInt(coupon.amount_off) / 100;
			}
			else if (coupon.percent_off) {
				totalPrice -= totalPrice * (parseInt(coupon.percent_off) / 100);
			}
			//Special case: special academic discount can be obtained with a coupon code,
			//but it's not actually a Stripe coupon - it's actually a special type of Stripe subscription plan (yearly-academic-special).
			//So in this case we create a price_override property to indicate the price
			else if (coupon.price_override) {
				totalPrice = parseInt(coupon.price_override) / 100;
			}
			if (totalPrice < 0) totalPrice = 0;

			//log(totalPrice)

			model.set('_page.totalAfterDiscounts', '$' + totalPrice);
			$('#total-after-discounts').show();
		}
		else if (data.errorMessage) {
			alert(data.errorMessage);
		}
		else alert(internalError);
	})
	.error(function() {
		alert(internalError);
	})
});


//DOING THIS FROM render-fns.js FOR NOW since it's not working right
/*
//For the country drop-down on the billing address form: populate states/provinces
app.fn('subscribe.changeCountry', module.exports.changeCountry);

//exported because it's used by render-fns.js
module.exports.changeCountry = function changeCountry(e, el) {
    var model = this.model;

    //Because this function is bound using x-bind change, it seems that the model does not get automatically updated,
    //so we update it manually
    var selectedCountryCode = jQuery(el).val()
    model.set('_page.user.address.countryCode', selectedCountryCode);
    //var selectedCountryCode = model.get('_page.user.address.countryCode');

    //note: for now at least, countryId is same as countryCode
    var statesQuery = model.query('states', {countryId: selectedCountryCode, $orderby: {name:1}});
    model.subscribe(statesQuery, function(err) {
        if (!statesQuery.get()) {
            model.del('_page.states');
        }
        else {
            statesQuery.ref('_page.states');
        }
    });
}
*/